import store, { modulesName } from '@/store';

const MAINTENANCE_RELOAD_FLAG = 'maintenanceReloadTriggered';

const checkMaintenanceMode = async () => {
  try {
    // Check if the app is in maintenance mode by requesting the app_offline.htm file with HEAD method
    const response = await fetch('/app_offline.htm', {
      method: 'HEAD',
      cache: 'no-store',
    });

    // ASP.NET Core Module maintenance mode returns 503 for EVERY request while
    // app_offline.htm exists, including the request for that file itself.
    // A real "not in maintenance" state returns 404 for app_offline.htm.
    const isMaintenance = response.status !== 404;

    if (isMaintenance) {
      if (sessionStorage.getItem(MAINTENANCE_RELOAD_FLAG)) {
        return true;
      }

      sessionStorage.setItem(MAINTENANCE_RELOAD_FLAG, '1');
      window.location.reload();
      return true;
    }

    sessionStorage.removeItem(MAINTENANCE_RELOAD_FLAG);
  } catch {
    // Network error: assume the app is not in maintenance mode
    // and let normal navigation/error handling proceed.
  }

  return false;
};

export const applyEvents = (router) => {
  router.beforeEach(async (to, _, next) => {
    if (await checkMaintenanceMode()) {
      return;
    }

    await store.dispatch(`${modulesName.userModuleName}/init`);

    const meta = to.matched
      .filter((x) => x.meta)
      .map((x) => x.meta)
      .reduce((x, y) => ({ ...x, ...y }), {});
    if (meta.authorization) {
      if (meta.authorization.authenticated === true) {
        if (!store.getters[`${modulesName.userModuleName}/authenticated`]) {
          store.dispatch(`${modulesName.userModuleName}/login`);
        }
      }

      if (meta.authorization.authenticated === false) {
        if (store.getters[`${modulesName.userModuleName}/authenticated`]) {
          return next({ name: 'home' });
        }
      }
    }
    if (meta.permissions) {
      const User = store.getters[`${modulesName.userModuleName}/profile`];
      if (!meta.permissions.every((p) => User.permissions.includes(p))) {
        return next('/');
      }
    }

    return next();
  });
};
